module.exports = __webpack_public_path__ + "img/nameatl11.c9aae40f.jpg";